import { melodyStaffLogic } from './melody_staff.logic';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import type { ActivityPlugin } from '../../core/types/activity.types';
import {
  MelodyStaffHost,
  MelodyStaffProjector,
  MelodyStaffStudent,
} from '../eval-blocks/MusicNativeViews';

export const melodyStaffPlugin: ActivityPlugin<'melody_staff'> = {
  ...melodyStaffLogic,
  displayName: GAME_MODE_CATALOG.melody_staff.displayName,
  icon: GAME_MODE_CATALOG.melody_staff.icon,
  HostView: MelodyStaffHost,
  StudentView: MelodyStaffStudent,
  ProjectorView: MelodyStaffProjector,
};

export { demoMelodyStaffPayload } from './melody_staff.logic';
